export enum PairsFrameLensGroupType {
  GroupByUnmappedItems = 0,
  SislogGroup = 1,
  GroupByZerezesMappingProperties = 2,
  GroupByIgluMappingProperties = 3
}